import type { UserRole } from './widget-registry';

export type { UserRole } from './widget-registry';

export type LayoutType = 'scanner-focus' | 'dashboard-first';

/**
 * Role-to-Layout mapping
 * OPERATOR: Scanner-focused minimal UI (quick actions)
 * STORE_MANAGER + ADMIN: Dashboard-first with analytics and widgets
 */
export const ROLE_LAYOUT_MAP: Record<UserRole, LayoutType> = {
  OPERATOR: 'scanner-focus',
  STORE_MANAGER: 'dashboard-first',
  ADMIN: 'dashboard-first',
  SUPER_ADMIN: 'dashboard-first',
};

/**
 * Get layout type for a given user role
 *
 * `null` = a BE-szerep ismert, de a dashboard-hozzárendelése termék-döntésre vár
 * (QA-100 ③). Ilyenkor a minimális, scanner-fókuszú nézet marad — ez a korábbi,
 * véletlen `undefined`-ág SZÁNDÉKOLT megfelelője, nem viselkedés-változás.
 */
export function getLayoutForRole(role: UserRole | null): LayoutType {
  if (role === null) return 'scanner-focus';

  return ROLE_LAYOUT_MAP[role];
}
